// Moment.js
import moment from "moment"
import "moment/dist/locale/nl"

moment.locale("nl")
